/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Info/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import Checkbox from './Checkbox/index'
import Details from './Details/index'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Info({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/SimilarPatients/Content/Content/SimilarPerson/Person/Info"
  
}) {
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
  return (<React.Fragment
>
<div
  data-testid="Info.Horizontal"
  data-view-path={viewPath}
 style={{'--mt-1-a3J8': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs}}
 className={`views-block ${styles.Horizontal}`}
>
<Checkbox
  viewPath={`${viewPath}/Checkbox`}
/>
<Details
  viewPath={`${viewPath}/Details`}
/>
</div>
{children}
</React.Fragment>)
}